import {
  GoogleMap,
  DirectionsRenderer,
  Marker
} from "@react-google-maps/api";
import { useState, useEffect, useContext } from "react";
import { TripContext } from "../../Context/TripContext";
import { getImages } from "../../../const";

const center = { lat: 41.85073, lng: -87.65126 };
const libraries = ["geometry", "drawing", "places"];
const grayTheme = [
  { "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] },
  { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
  { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
  { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] },
  { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] },
  { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] },
  { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
  { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] },
  { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] },
  { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] },
  { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
  { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] },
  { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
  { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] },
  { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] },
  { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] },
  { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] },
  { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }
];
const TripFullMap = ({ isLoaded, tmHeight, tripInputData }) => {

  const { tripData } = useContext(TripContext);

  const [directions, setDirections] = useState(null);
  const [itineraryMarkers, setItineraryMarkers] = useState([]);

  const mapTrip = () => {
    if (isLoaded && 'origin' in tripData && 'park_list' in tripData) {

      const directionsService = new window.google.maps.DirectionsService();

      const dest = tripInputData?.trip_type == "round-trip" ? tripData.origin : tripData?.park_list.slice(-1)[0];

      const intermediateStops = tripData?.park_list.map((v, i) => {
        return { location: v, stopover: true };
      });

      /*if(additionalStops.length > 0) {
        console.log("adding stops",additionalStops);
        intermediateStops.push(...additionalStops.map((v, i) => {
          return { location: v, stopover: true };
        }));
      }

      console.log("stops",additionalStops,intermediateStops);*/

      const routeData = {
        origin: tripData.origin,
        destination: dest,
        waypoints: intermediateStops,
        travelMode: window.google.maps.TravelMode.DRIVING
      };

      if(tripInputData?.scenic_mode) routeData.avoidHighways = true;

      console.log(routeData);

      directionsService.route(routeData,
        (result, status) => {
          if (status === "OK") {
            setDirections(result);
          }
        }
      );

    }
    if (isLoaded && tripData?.park_list?.length) {

      const geocoder = new window.google.maps.Geocoder();
      const locations = [];

      tripData.park_list.forEach((place, index) => {
        geocoder.geocode({ address: place }, (results, status) => {
          if (status === "OK") {
            locations.push({
              position: results[0].geometry.location,
              index
            });

            if (locations.length === tripData.park_list.length) {
              setItineraryMarkers(locations);
            }
          }
        });
      });

    }
  }

  useEffect(() => {
    mapTrip();
  }, [isLoaded, tripData, tripInputData]);

  //console.log("tripData", tripData)
  //console.log("directions", directions)
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <GoogleMap
      center={center}
      zoom={14}
      mapContainerStyle={{ width: "100%", height: tmHeight }}
      options={{
        mapTypeControl: false,
        fullscreenControl: false,
        mapTypeId: "roadmap",
        styles: grayTheme
      }}
    >
      {/* {directions && <DirectionsRenderer directions={directions} />} */}
      {directions && (
        <DirectionsRenderer
          directions={directions}
          options={{
            suppressMarkers: true,
            polylineOptions: {
              strokeColor: "#fa835f",
              strokeOpacity: 0.9,
              strokeWeight: 4
            }
          }}
        />
      )}

      {directions && (
        <>
          {/* Start marker */}
          <Marker
            position={{
              lat: directions.routes[0].legs[0].start_location.lat(),
              lng: directions.routes[0].legs[0].start_location.lng()
            }}
            zIndex={1000}
            icon={{
              url: getImages("start.png"),
              scaledSize: new window.google.maps.Size(32, 32)
            }}
          />

          {/* Waypoints + destination */}
          {directions &&
            directions.routes[0].legs.map((leg, index) => (
              <Marker
                key={index}
                position={{
                  lat: leg.end_location.lat(),
                  lng: leg.end_location.lng()
                }}
                icon={{
                  url: getImages("park.png"),
                  scaledSize: new window.google.maps.Size(32, 32)
                }}
                label={{
                  text: `${index + 1}`,
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: "500",
                  lineHeight: "24px"
                }}
              />
            ))}
            {itineraryMarkers.map((marker, index) => (
              <Marker
                key={index}
                position={{
                  lat: marker.position.lat(),
                  lng: marker.position.lng()
                }}
                icon={{
                  url: getImages("icon-park-pin.png"), // your custom icon
                  scaledSize: new window.google.maps.Size(36, 36)
                }}
              />
            ))}
        </>
      )}
    </GoogleMap>
  );
}

export default TripFullMap;